import { render, staticRenderFns } from "./MintingParchment.vue?vue&type=template&id=cfa27c28&scoped=true&"
import script from "./MintingParchment.vue?vue&type=script&lang=js&"
export * from "./MintingParchment.vue?vue&type=script&lang=js&"
import style0 from "./MintingParchment.vue?vue&type=style&index=0&id=cfa27c28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa27c28",
  null
  
)

export default component.exports